/** replaceUnderscore helper takes a string arg and uses ES2021 'replaceAll', replacing all instances of underscores with a space */

export const replaceUnderscore = value => {
  return value.replaceAll('_', ' ')
}
